import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { addressString } from '@core/util/address';
import { Address } from '@models/address';
import { MortgageBroker, MortgageBrokerage } from '@models/brokerage';
import { MatterMortgage } from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';
import { ICON } from '@core/util/icon';
import {
	MortgageBrokerModalComponent,
	MortgageBrokerModalData,
} from '../mortgage-broker-modal/mortgage-broker-modal.component';
import {
	MortgageBrokerageModalComponent,
	MortgageBrokerageModalData,
} from '../mortgage-brokerage-modal/mortgage-brokerage-modal.component';

@Component({
	selector: 'app-mortgage-broker',
	templateUrl: './mortgage-broker.component.html',
	animations: [openClose()],
	standalone: false,
})
export class MortgageBrokerComponent {
	public _mortgage: MatterMortgage;
	public ICON = ICON;
	public showBrokerageSearch = false;
	public showBrokerage = false;

	@Input() set mortgage(_mortgage: MatterMortgage) {
		this._mortgage = _mortgage;
	}

	constructor(
		private mortgageDispatch: MatterMortgageDispatch,
		private dialog: MatDialog,
	) {}

	updateFee(value: number) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			brokerFee: value,
		});
	}

	onSelectMortgageBrokerage(mortgageBrokerage: MortgageBrokerage) {
		this.showBrokerageSearch = false;
		this.mortgageDispatch.SetMortgageBrokerage(
			this._mortgage.id,
			mortgageBrokerage.id,
		);
	}

	onSelectMortgageBroker(mortgageBroker: MortgageBroker) {
		this.showBrokerageSearch = false;
		this.mortgageDispatch.SetMortgageBroker(
			this._mortgage.id,
			mortgageBroker.brokerageId,
			mortgageBroker.id,
		);
	}

	toggleShowSearchBrokerage() {
		this.showBrokerageSearch = !this.showBrokerageSearch;
	}

	setAddress(address: Address): string {
		return addressString(address);
	}

	brokerageDropdownOptionSelect(event) {
		const data: MortgageBrokerageModalData = {
			brokerage: this._mortgage?.brokerage,
			matterMortgageId: this._mortgage.id,
		};

		switch (event.result.name) {
			case 'Edit':
				this.dialog.open(MortgageBrokerageModalComponent, { data });
				break;
			case 'Remove':
				this.mortgageDispatch.RemoveMortgageBrokerage(this._mortgage.id);
				break;
		}
	}

	brokerDropdownOptionSelect(event) {
		const data: MortgageBrokerModalData = {
			brokerage: this._mortgage?.brokerage,
			matterMortgageId: this._mortgage.id,
		};
		switch (event.result.name) {
			case 'Edit':
				this.dialog.open(MortgageBrokerModalComponent, { data });
				break;
			case 'Remove':
				this.mortgageDispatch.RemoveMortgageBroker(this._mortgage.id);
				break;
		}
	}

	onCreateBrokerage(searchTerm: string) {
		this.showBrokerageSearch = false;
		this.dialog.open(MortgageBrokerageModalComponent, {
			data: { matterMortgageId: this._mortgage.id, searchTerm },
		});
	}

	onCreateBroker(searchTerm: string) {
		this.dialog.open(MortgageBrokerModalComponent, {
			data: {
				matterMortgageId: this._mortgage.id,
				searchTerm,
				brokerage: this._mortgage?.brokerage,
			},
		});
	}
}
